module.exports = __webpack_public_path__ + "static/media/8.2b2cf7ea.jpg";